import { ArrowLeft } from 'lucide-react'
import { Link } from 'wouter'
import { useI18n } from '../i18n'

export function NotFoundPage() {
  const { t } = useI18n()
  return (
    <div className="grid min-h-[calc(100vh-72px)] place-items-center px-5 text-center">
      <div><span className="text-[10px] font-bold uppercase tracking-[0.16em] text-moss">{t('notFound.label')}</span><h1 className="mt-4 font-serif text-6xl tracking-tighter">{t('notFound.title')}</h1><Link href="/" className="mt-7 inline-flex items-center gap-2 rounded-full bg-ink px-5 py-3 text-xs font-semibold text-paper"><ArrowLeft size={14} /> {t('notFound.home')}</Link></div>
    </div>
  )
}
